<template>
    <div>
        <div style="display:none">
            <audio controls="controls" @canplay="getDuration" @play="onplay" @ended="onEnded" ref="audioEle">
                <source :src="url || ''" type="audio/mpeg" />
            </audio>
        </div>
        <div :class="styless? 'voice-bg-dp':'voice-bg'" @click="handlePlay">
            <div class="voiceImg">
                <img v-if="isPlaying" src="../../static/images/isPlaying.gif" alt=""/>
                <img v-else src="../../static/images/noPaying.png" alt=""/>
            </div>
            <div class="voiceSpan">
                <span class="span1">{{ duration || 0 }}'s</span>
                <span class="span2">{{ styleTextRop||'' }}</span>
            </div>
        </div>
    </div>
</template>
<script>
    import utils from '../lib/util'
    export default {
        name:"audioStyle",
        props: {
            audioUrl:String,
            styleText:String,
            styles:String,
        },
        data() {
            return {
                url: '',
                styleTextRop:'',
                timer: null,
                isPlaying: false,
                currentTime: 0,
                duration:0,
                styless:''
            }
        },
        watch: {},
        mounted(){
            this.url = this.audioUrl
            this.styleTextRop = this.styleText
            this.styless = this.styles
        },
        methods:{
            getDuration() {
                let that  = this
                if (!Number.isFinite(that.$refs.audioEle.duration)) {
                    that.$refs.audioEle.currentTime = Number.MAX_SAFE_INTEGER;
                    that.$refs.audioEle.currentTime = 0;
                } else {
                    that.duration = parseInt((that.audioUrl && that.$refs.audioEle.duration) || 0)
                }
            },
            handlePlay() {
                this.$emit('getPlays')
            },
            fatherPlay(plays,nPlays=-1){
                if(this.$refs.audioEle.paused||plays==1000){
                    if(plays>0||nPlays==-1){
                        this.endAudio();
                        let audio = this.$refs.audioEle;
                        if (!this.isPlaying) {
                            audio.play();
                            this.isPlaying = true;
                            this.watchEnd();
                        }
                    }else{
                        this.$message({showClose: true,message: `该音频只能播放${nPlays}次`})
                    }
                }
            },
            watchEnd() {
                let that = this;
                this.timer = setTimeout(() => {
                    that.isPlaying = false;
                }, (that.duration + 1) * 1000);
            },
            
            judgePaying(){
                return this.$refs.audioEle.paused
            },

            onplay(){
                this.$emit('startPlaying')
            },

            onEnded(){
                this.$emit('endPlaying')
            },

            endAudio(){
                this.$refs.audioEle.pause()
                this.$refs.audioEle.currentTime = 0
                this.isPlaying = false;
            },

            goPlay(){
                this.isPlaying = false;
                this.$refs.audioEle.currentTime = 0
                this.handlePlay()
            }

        },
        beforeDestroy() {
            clearTimeout(this.timer);
        }
    }
</script>
<style scoped lang="less">
    .voice-bg{
        background: rgb(0, 75, 180);
        // width: 180px;
        height: 33px;
        border-radius: 4px;
        position: relative;
        cursor: pointer;
        .voiceImg{
            position: absolute;
            left: 10%;
            top: 20%;
            right: 75%;
            bottom: 20%;
            height: 60%;
            display: inline-block;
            img{
                height: 100%;
            }
        }
        .voiceSpan{
            position: absolute;
            left: 45px;
            top: 0;
            bottom: 0;
            right: 0;
            line-height: 30px;
            .span1{
                font-size: 13px;
                color: #fff;
            }
            .span2{
                margin-left: 22%;
                color: #fff;
                font-size: 12px;
            }
        }
    }
    .voice-bg-dp{
        background: #fff;
        // width: 180px;
        height: 31px;
        border-radius: 4px;
        position: relative;
        border: 1px solid #999;
        cursor: pointer;
        .voiceImg{
            position: absolute;
            left: 10%;
            top: 20%;
            right: 75%;
            bottom: 20%;
            height: 60%;
            display: none;
            img{
                height: 100%;
            }
        }
        .voiceSpan{
            position: absolute;
            left: 15px;
            top: 0;
            bottom: 0;
            right: 0;
            padding: 5px 0;
            .span1{
                font-size: 13px;
                color: #fff;
                display: none;
            }
            .span2{
                margin-left: 22%;
                color: #000;
                font-size: 14px;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/audioStyle.vue